module.exports = __webpack_public_path__ + "img/header-engagementRingsRosegold.cacc6aa.jpg";